module.exports = __webpack_public_path__ + "static/media/back_cards-07.e9ac9257.png";